import About from "../componants/about/About";
import AccountPage from "../componants/account-page/AccountPage";
import Cart from "../componants/cart/Cart";
import CheckoutPage from "../componants/checkout-page/CheckoutPage";
import Contact from "../componants/contact/Contact";
import FavoritePage from "../componants/favorite-page/FavoritePage";
import Home from "../componants/home/Home";
import LogIn from "../componants/login/LogIn";
import NotFoundPage from "../componants/notfound-page/NotFoundPage";
import OrderPage from "../componants/order-page/OrderPage";
import ProductDetailsPage from "../componants/productdetail-page/ProductDetailsPage";
import ProductsCategoryPage from "../componants/product-catogery/ProductsCategory";
import ProductsPage from "../componants/product-page/ProductsPage";
import SearchPage from "../componants/search/SearchPage";
import SignUp from "../componants/sign-up/SignUp";
import WishList from "../componants/wishlist/WishList";

export const ROUTES_CONFIG = [
  { path: "/", element: <Home /> },
  { path: "/contact", element: <Contact /> },
  { path: "/about", element: <About /> },
  { path: "/details", element: <ProductDetailsPage /> },
  { path: "/category", element: <ProductsCategoryPage /> },
  { path: "/products", element: <ProductsPage /> },
  { path: "/favorites", element: <FavoritePage /> },
  { path: "/wishlist", element: <WishList /> },
  { path: "/cart", element: <Cart /> },
  { path: "/checkout", element: <CheckoutPage /> },
  { path: "/order", element: <OrderPage /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/login", element: <LogIn /> },
  { path: "/profile", element: <AccountPage /> },
  { path: "/search", element: <SearchPage /> },
  { path: "*", element: <NotFoundPage /> },
];
